@use '@hevoio/hevo-ui-toolkit/styles/variables' as v;

.modalContent {
  overflow: hidden;
}

.modal {
  width: 100%;
}

.headerContent {
  display: flex;
  align-items: center;
  gap: v.$spacer-12;
  flex: 1;
  min-width: 0;
}

.headerIcon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  color: v.$text-strong-950;
  flex-shrink: 0;
}

.headerTitle {
  font-size: v.$font-size-subheader;
  font-weight: v.$font-weight-medium;
  line-height: 24px;
  color: v.$text-strong-950;
}

.description {
  font-size: v.$font-size-body-large;
  font-style: normal;
  font-weight: v.$font-weight-normal;
  line-height: v.$line-height-title;
  letter-spacing: -0.084px;
  color: v.$text-strong-950;
}

.actionBtn {
  height: 36px;
  padding: v.$spacer-8;
  border-radius: v.$border-radius-8;
}

.confirmField {
  margin-top: v.$spacer-16;
  display: flex;
  flex-direction: column;
  gap: v.$spacer-4;
}

.confirmLabelRow {
  display: flex;
  align-items: center;
}

.confirmLabel {
  font-size: v.$font-size-body-large;
  font-style: normal;
  font-weight: v.$font-weight-medium;
  line-height: v.$line-height-title;
  letter-spacing: -0.084px;
  color: v.$text-strong-950;
}

.required {
  font-size: v.$font-size-body;
  font-weight: v.$font-weight-medium;
  color: v.$primary;
  line-height: v.$line-height-body;
}
